<template>
    <fieldset class="form-group">
        <legend>
            {{ filter.displayName }}
            <span class="unit" v-if="filter.unit"> ({{ filter.unit }})</span>
        </legend>
        <div :id="filter.displayName" role="radiogroup" tabindex="-1" class="btn-group btn-group-toggle">
            <template v-for="(option, index) in filter.options" :key="filterName + '-' + index">
                <label class="btn btn-secondary" :class="{ active: internalValue === option.value }">
                    <input
                        type="radio"
                        :name="filterName"
                        :value="option.value"
                        :checked="internalValue === option.value"
                        @change="onChange(option.value)"
                    >
                    {{ option.text || option.value }}
                </label>
            </template>
        </div>
    </fieldset>
</template>

<script>

    export default {
        name: 'RadioButtonGroup',
        props: {
            modelValue: {
                required: false
            },
            filter: {
                type: Object,
                required: true,
                default: () => ({ options: [] })
            },
            filterName: {
                type: String,
                required: true
            }
        },
        computed: {
            internalValue() {
                return this.modelValue;
            }
        },
        methods: {
            onChange(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        }
    }
</script>
